/**
 * API
 */
import {
  axios
} from '@/utils/request'

const baseURL = '/jpaas-jiop-web-server'
function getCookieData (cookieName) {
  try {
    var name = cookieName + '='
    var cookieMsg = document.cookie.replace(/%/g, '%25')
    var decodedCookie = decodeURIComponent(cookieMsg)
    var cookieArray = decodedCookie.split(';')
    for (var i = 0; i < cookieArray.length; i++) {
      var cookie = cookieArray[i]
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1)
      }
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length)
      }
    }
    return ''
  } catch (err) {
    console.log(err, 'cookieErr')
  }
}
// 使用示例
const token = getCookieData('accessToken')

const api = {
  matterList: baseURL + '/interface/Ucenter/list', // 查询事项表单
  // 情形选择
  findSituationByIid: baseURL + '/interface/situation/findSituationByIid',
  // 根据选项id查询上传材料id
  findoptionvalfileidByIid: baseURL + '/interface/situation/findoptionvalfileidByIid',
  // 草稿表单提交
  formSubmit: baseURL + '/interface/draft/formSubmit',
  // 用户中心查询
  findHandlingList: baseURL + '/interface/handling/findHandlingList',
  // 取消板件接口
  cancelHandling: baseURL + '/interface/handling/cancelHandling',
  // 删除办件接口
  draftDelete: baseURL + '/interface/draft/draftDelete',
  // 获取事项步骤配置
  findReportConfigByIid: baseURL + '/interface/reportconfig/findReportConfigByIid',

  findMaterialByIids: baseURL + '/interface/information/findMaterialByIids', // 查询事项表单
  // 判断是否登录
  isLogin: baseURL + '/interface/buttjoint/jisbuttsuccess',
  // 获取登录页面url
  getLoginUrl: baseURL + '/interface/buttjoint/jisurl',
  // 查询办件获取短信验证码
  getVerifyCode: baseURL + '/interface/verify/getVerifyCode',
  // 退出登录
  outLogin: baseURL + '/interface/buttjoint/loginOut',
  matterFilterList: baseURL + '/front/matter/matter-filter-list', // 单事项列表页轮播数据
  districtList: baseURL + '/front/matter/district-list', // 区划数据查询
  groupList: baseURL + '/front/matter/group-list', // 根据地区查询区
  // 根据情形选择的材料id获取材料上传页的数据
  getMaterialInfo: baseURL + '/interface/material/findMaterialByIids',
  // 材料上传接口
  uploadFile: baseURL + '/interface/handling/uploadFile',
  // 获取草稿详情
  getDraftDetail: baseURL + '/interface/draft/showDetail',
  // 材料提交草稿
  materialSubmit: baseURL + '/interface/draft/formSubmit',
  // 查询是否有草稿接口
  queryDraft: baseURL + '/interface/draft/queryDraft',

  findItemBeanSimple: baseURL + '/front/matter/find-item-bean-simple', // 查询办事指南信息简洁版

  findOption: baseURL + '/interface/handling/findDimensionValue', // 查询维度
  // 查询表单提交加密公钥
  getPublicKey: baseURL + '/interface/handling/getPublicKey',

  // 查询智能填报字段是否开启
  findSmartFill: baseURL + '/interface/baseconfig/find-smart-fill',
  // 查询智能填报字段数据
  findFielddata: baseURL + '/interface/fielddata/find'

}

export const jiopWebAPI = {
  getPublicKey (parameter) {
    return axios({
      url: api.getPublicKey,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  findOption (parameter) {
    return axios({
      url: api.findOption,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  findItemBeanSimple (parameter) {
    return axios({
      url: api.findItemBeanSimple,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  queryDraft (parameter) {
    return axios({
      url: api.queryDraft,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  findMaterialByIids (parameter) {
    return axios({
      url: api.findMaterialByIids,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  isLogin (parameter) {
    return axios({
      url: api.isLogin,
      method: 'get',
      params: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  getLoginUrl (parameter) {
    return axios({
      url: api.getLoginUrl,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  findReportConfigByIid (parameter) {
    return axios({
      url: api.findReportConfigByIid,
      method: 'post',
      params: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  getVerifyCode (parameter) {
    return axios({
      url: api.getVerifyCode,
      method: 'get',
      params: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  outLogin (parameter) {
    return axios({
      url: api.outLogin,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  groupList (parameter) {
    return axios({
      url: api.groupList,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  districtList (parameter) {
    return axios({
      url: api.districtList,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  matterFilterList (parameter) {
    return axios({
      url: api.matterFilterList,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  getMaterialInfo (parameter) {
    return axios({
      url: api.getMaterialInfo,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  uploadFile (parameter) {
    return axios({
      url: api.uploadFile,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': JSON.parse(sessionStorage.getItem('JiopUserInfo')).accessToken,
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  getDraftDetail (parameter) {
    return axios({
      url: api.getDraftDetail,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  materialSubmit (parameter) {
    return axios({
      url: api.materialSubmit,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  draftDelete (parameter) {
    return axios({
      url: api.draftDelete,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  cancelHandling (parameter) {
    return axios({
      url: api.cancelHandling,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  findHandlingList (parameter) {
    return axios({
      url: api.findHandlingList,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  matterList (parameter) {
    return axios({
      url: api.matterList,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  formSubmit (parameter) {
    return axios({
      url: api.formSubmit,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  findSituationByIid (parameter) {
    return axios({
      url: api.findSituationByIid,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  findoptionvalfileidByIid (parameter) {
    return axios({
      url: api.findoptionvalfileidByIid,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },

  findSmartFill (parameter) {
    return axios({
      url: api.findSmartFill,
      method: 'get',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  findFielddata (parameter) {
    return axios({
      url: api.findFielddata,
      method: 'get',
      params: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  }
}
